import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// export interface DialogData {
//   animal: string;
//   name: string;
// }

@Component({
  selector: 'app-choose-status',
  templateUrl: './choose-status.component.html',
  styleUrls: ['./choose-status.component.css']
})
export class ChooseStatusComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ChooseStatusComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }


  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
